"use client";

// src/components/RainbowKitProvider/chainIcons/zetachain.svg
var zetachain_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 178 178"><circle cx="89" cy="89" r="89" fill="%23005741"/><path fill="%23fff" d="M112.109 108.673v12.02H62.523c.684-7.911 3.236-13.477 12.064-21.304l37.522-32.01v28.09h13.507V43.79H48.813v25.76H62.32V57.297h40.803L65.784 89.163l-.089.085c-15.648 13.854-16.892 25.036-16.892 38.211v6.751h76.818v-25.527h-13.507z"/></svg>';
export {
  zetachain_default as default
};
